import styled from 'styled-components';

import { OnboardingTitle } from '@/pages/Onboarding/components/Title';

export const TitleStyles = styled(OnboardingTitle)`
  padding: 24px 0 0;
`;
